import {
  GET_EVENT_STATUS_UPDATE_REQUEST,
  GET_EVENT_STATUS_UPDATE_SUCCESS,
  GET_EVENT_STATUS_UPDATE_FAILURE,
  WIN_LOSE_STATUS_WS_UPDATE
} from 'Store/constants';

const initialState = {
  data: [],
  isFetched: false,
  isLoading: null,
  error: null
};

export default (state = initialState, action) => {
  switch (action.type) {
    case GET_EVENT_STATUS_UPDATE_REQUEST:
      return { ...state, isFetched: false, isLoading: true, error: null };

    case GET_EVENT_STATUS_UPDATE_SUCCESS: {
      let newState = [...state.data];

      action.payload.forEach(statusUpdate => {
        const targetEventStatusIndex = newState.findIndex(eventStatus => {
          return eventStatus.eventId === statusUpdate.eventId
          && eventStatus.marketId === statusUpdate.marketId
          && eventStatus.outcomeNo === statusUpdate.outcomeNo;
        });

        if (targetEventStatusIndex !== -1) {
          newState[targetEventStatusIndex] = {
            ...statusUpdate
          };
        } else {
          newState.push(statusUpdate);
        }
      });

      return {
        data: newState,
        isFetched: true,
        isLoading: false,
        error: null
      };
    }

    case GET_EVENT_STATUS_UPDATE_FAILURE:
      return {
        ...state,
        isFetched: true,
        isLoading: false,
        error: action.payload
      };

    case WIN_LOSE_STATUS_WS_UPDATE: {
      const { eventId, marketId, outcomeNo, winLoseStatus, marketScoreDisplay } = action.payload;

      const targetEventStatusIndex = state.data.findIndex(eventStatus => {
        return eventStatus.eventId === eventId
        && eventStatus.marketId === marketId
        && eventStatus.outcomeNo === outcomeNo;
      });

      let newState = { ...state };

      if (targetEventStatusIndex !== -1) {
        newState.data[targetEventStatusIndex] = {
          ...newState.data[targetEventStatusIndex],
          status: winLoseStatus,
          currentScoreDisplay: marketScoreDisplay
        };
      }

      return newState;
    }
    default:
      return state;
  }
};
